'use strict';
module.exports = function CanvasTextSizer(themeProcessor) {
	if (!themeProcessor || !themeProcessor.cssFont) {
		throw new Error('invalid-args');
	}
	const self = this,
		canvas = document.createElement('canvas'),
		ctx = canvas.getContext('2d');
	self.textWidth = function (text, fontMetrics) {
		if (typeof text !== 'string' || !fontMetrics) {
			throw new Error('invalid-args');
		}
		const basicSize = 10,
			fontInfo = Object.assign({}, fontMetrics, {fontSize: basicSize}),
			cssFont = themeProcessor.cssFont(fontInfo);
		ctx.font = cssFont;
		return ctx.measureText(text).width / basicSize;
	};
};
